import Api from './base.api';

import { User } from '@types/User.t';

interface IAuthApi {
  login: (body: User) => Promise<any>,
  apply: (body: User) => Promise<any>,
  patch: (id: string, body: User) => Promise<any>
}

class AuthApi extends Api implements IAuthApi{
  login = (body: User) => this.request('login', {
    method: 'post',
    body: JSON.stringify(body)
  });

  fetchCurrentUser = () => this.request('users/me');
}

export default new AuthApi();
